import { Link } from "react-router-dom";
import type { AttentionItem, OperationsSnapshot, TaskStatus, WorkTask } from "../../domain/operations";
import { activeAttention, todaySummary, visibleBlocks, visibleTasksInBlock } from "../../domain/operationsQueries";
import { AttentionCard } from "./AttentionCard";
import { CompactBlock } from "./CompactBlock";
import { ExpandedBlock } from "./ExpandedBlock";
import { TodaySummary } from "./TodaySummary";

interface DesktopTodayProps {
  snapshot: OperationsSnapshot;
  onStatus(taskId: string, status: TaskStatus, blockerNote?: string): void;
  onReview(item: AttentionItem): void;
  onResolve(id: string): void;
}

export function DesktopToday({ snapshot, onStatus, onReview, onResolve }: DesktopTodayProps) {
  const blocks = visibleBlocks(snapshot);
  const nowBlock = blocks[0];
  const attention = activeAttention(snapshot);

  return (
    <section className="desktop-view" aria-label="Today's operations">
      <TodaySummary summary={todaySummary(snapshot)} />
      <div className="desktop-layout">
        <section className="schedule-panel">
          <div className="section-heading">
            <div><h2>Operational work blocks</h2><p>Sequenced by location, timing, and shared resources. Event date does not force the schedule.</p></div>
          </div>
          {nowBlock && <ExpandedBlock block={nowBlock} tasks={visibleTasksInBlock(snapshot, nowBlock)} snapshot={snapshot} onStatus={onStatus} />}
          {blocks.slice(1).map((block) => (
            <CompactBlock key={block.id} block={block} tasks={visibleTasksInBlock(snapshot, block)} snapshot={snapshot} onStatus={onStatus} />
          ))}
        </section>
        <aside className="attention-panel">
          <div className="section-heading small"><div><h2>Needs attention</h2><p>Resolve before service.</p></div><Link to="/attention">View all</Link></div>
          {attention.map((item) => {
            const event = snapshot.events.find((entry) => entry.id === item.eventId);
            return event ? <AttentionCard key={item.id} item={item} event={event} onReview={() => onReview(item)} onResolve={() => onResolve(item.id)} /> : null;
          })}
          {attention.length === 0 && <div className="empty-state"><strong>All clear</strong><p>No unresolved attention items.</p></div>}
        </aside>
      </div>
    </section>
  );
}
